import { useRef, useState, useEffect, useLayoutEffect } from 'react';
import { Grid, useMediaQuery, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import {
	EventNoteSharp,
	BusinessCenterSharp,
	CodeSharp,
	EngineeringSharp,
	ArchitectureSharp,
	GroupsSharp,
	AssignmentTurnedInSharp,
} from '@mui/icons-material';

const useWindowSize = () => {
	const [size, setSize] = useState([0, 0]);
	useLayoutEffect(() => {
		function updateSize() {
			setSize([window.innerWidth, window.innerHeight]);
		}
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);
	return size;
};

const Flow = (): JSX.Element => {
	const parentRef = useRef(null);
	const lastItem = useRef(null);
	const itemImg = useRef(null);
	const itemText = useRef(null);
	const [leftShift, setLeftShift] = useState(0);
	// const [bottomShift, setBottomShift] = React.useState(0);
	const [width, height] = useWindowSize();
	const borderWidth = 2;

	const auditRef_1 = useRef(null);

	let { t } = useTranslation(['project_maintain-form']);
	const theme = useTheme();
	const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
		defaultMatches: true,
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});
	const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
		defaultMatches: true,
	});

	useEffect(() => {
		//* get left padding of lastItem
		if (!lastItem.current) return;
		const lastItemPaddingLeft = window.getComputedStyle(lastItem.current).paddingLeft;
		// console.log({ lastItemPaddingLeft });
		// const lastItemHeight = window.getComputedStyle(lastItem.current).height;
		// console.log({ lastItemHeight });
		// const lastItemPaddingTop = window.getComputedStyle(lastItem.current).paddingTop;

		//* get width of itemImg
		if (!itemImg.current) return;
		const itemImgWidth = window.getComputedStyle(itemImg.current).width;
		// console.log({ itemImgWidth });

		//* get parent padding left
		if (!parentRef.current) return;
		const parentPaddingLeft = window.getComputedStyle(parentRef.current).paddingLeft;
		// console.log({ parentPaddingLeft });

		// console.log(parseInt(lastItemPaddingLeft) + parseInt(itemImgWidth) / 2);
		// setLeftShift(parseInt(lastItemPaddingLeft) + parseInt(itemImgWidth)); // 3px -> half of border width
		setLeftShift(
			parseInt(lastItemPaddingLeft) +
				parseInt(itemImgWidth) / 2 +
				parseInt(parentPaddingLeft) -
				borderWidth / 2,
		);
		// setBottomShift(parseInt(lastItemHeight) / 4);
		// setBottomShift(parseInt(lastItemPaddingTop));
		// console.log({ leftShift });
	}, [width]);

	const flow_mock = [
		{
			headline: t('flow_subheadline_1'),
			body: t('flow_description_1'),
			image: BusinessCenterSharp,
		},
		{
			headline: t('flow_subheadline_2'),
			body: t('flow_description_2'),
			image: EventNoteSharp,
		},
		{
			headline: t('flow_subheadline_3'),
			body: t('flow_description_3'),
			image: ArchitectureSharp,
		},
		{
			headline: t('flow_subheadline_4'),
			body: t('flow_description_4'),
			image: CodeSharp,
		},
		{
			headline: t('flow_subheadline_5'),
			body: t('flow_description_5'),
			image: AssignmentTurnedInSharp,
		},
		{
			headline: t('flow_subheadline_6'),
			body: t('flow_description_6'),
			image: GroupsSharp,
		},
		{
			headline: t('flow_subheadline_7'),
			body: t('flow_description_7'),
			image: EngineeringSharp,
		},

		// {
		// 	headline: '7. Erweiterung',
		// 	body: 'Wir gestalten Ihre Anwendung benutzerfreundlich und intuitiv.',
		// 	image: ExtensionSharpIcon,
		// },
	];

	return (
		<Grid container spacing={5}>
			<Grid item container xs={12}>
				<Typography variant='h4' component='h4' gutterBottom sx={{ fontWeight: 700 }}>
					{t('flow_headline')}
				</Typography>
			</Grid>

			<Grid
				ref={parentRef}
				item
				container
				xs={12}
				spacing={3}
				position={'relative'}
				overflow={'hidden'}
				mt={3}
				sx={{
					paddingTop: '0px !important',
					paddingBottom: '10px',
					borderLeft: '2px solid',
					borderColor: theme.palette.secondary.main,
				}}
			>
				{/* <div
					style={{
						position: 'absolute',
						width: '100%',
						// height: '100%',
						height: 'calc(100% - 30px)',
						overflow: 'hidden',
						left: `${leftShift}px`,
						// bottom: `${bottomShift}px`,
						bottom: 0,
					}}
				>
					<div
						style={{
							position: 'absolute',
							width: '100%',
							height: '100%',
						}}
						className='animated-border-box-glow'
					/>
					<div
						style={{
							position: 'absolute',
							width: '100%',
							height: '100%',
							left: `${borderWidth}px`,
							bottom: `${borderWidth}px`,
							backgroundColor: theme.palette.background.paper,
						}}
					/>
				</div> */}

				{flow_mock.map((item, i) => {
					const Icon = item.image;

					return (
						<Grid item container direction='row' xs={12} key={i} position={'relative'} zIndex={10}>
							<Grid item xs={isSm ? 1 : 2}>
								{/* <ImageLoader delay={true} intersectViewportCheck={true} childRef={auditRef_1}> */}
								{/* <CheckSharpIcon sx={{ width: 24, height: 15 }} />; */}
								{/* <item.image sx={{ width: 40, height: 45 }} /> */}
								<Icon sx={{ width: 40, height: 45 }} />
								{/* </ImageLoader> */}
							</Grid>

							<Grid item xs pl={0}>
								<Typography variant='h6' component='h4' gutterBottom sx={{ fontWeight: 700 }}>
									{item.headline}
								</Typography>
								<Typography variant='body1' component='p' color='text.secondary'>
									{item.body}
								</Typography>
							</Grid>
						</Grid>
					);
				})}
				{/* 
				<Grid
					ref={lastItem}
					item
					container
					direction='row'
					xs={12}
					position={'relative'}
					zIndex={10}
				>
					<Grid item xs={0.8} ref={itemImg}></Grid>

					<Grid item xs pl={4} ref={itemText}>
						<Typography variant='h5' component='h3' gutterBottom sx={{ fontWeight: 700 }}>
							Ganzheitliche Betreuung Ihrer Anwendung und auf Wunsch auch Ihres Unternehmens
						</Typography>
					</Grid>
				</Grid> */}
			</Grid>
		</Grid>
	);
};

export default Flow;
